import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class AxlesNumbers extends Component {
  render() {
    return (
      <EntityList apiRoute='api/axlesnumbers' title="Remorque - Nombres d'essieux" editTitle="Nombre d'essieux" displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default AxlesNumbers;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/axlesNumbers.js
 **/